import { Grid, Typography } from '@material-ui/core';
import CreatorDetailedInsightsCard from './ytCreatorDetailedInsightsCard';
import { withStyles } from '@material-ui/core/styles';
import { useParams, useLocation } from 'react-router-dom';

function YtDetailedInsights({ classes }) {
  const { keyword } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const query = new URLSearchParams(window.location.href);
  const searchKeyword = query.get('keyword')
  // console.log('searchKeyword',searchKeyword)
  // console.log('keyword___',keyword)
  const startDate = queryParams.get("start_date") !== "Invalid date" ? queryParams.get("start_date") : null
  const endDate = queryParams.get("end_date") !== "Invalid date" ? queryParams.get("end_date") : null

  console.log("startDate", startDate)

  return (
    <Grid container direction="column">
      <Grid item md={12} className={classes.header}>
        <Grid item md={12}>
          <Typography style={{ color: 'black' }}>DETAILED INSIGHTS</Typography>
        </Grid>
      </Grid>
      {/* <Grid item md={12}>
            <Typography style={{fontSize:30,marginTop:30,marginLeft:50,fontWeight:550,textAlign:'start'}}>Detailed Insights for "Category Clicked"</Typography>
        </Grid > */}
      <Grid item md={12} style={{ marginLeft: 33, textAlign: 'start' }}>
        <CreatorDetailedInsightsCard keyword={keyword} startDate={startDate} endDate={endDate} searchKeyword={searchKeyword}></CreatorDetailedInsightsCard>
      </Grid>
    </Grid>
  );
}

const styles = (theme) => ({
  header: {
    color: '#4A4A4A',
    fontSize: '20px',
    textAlign: 'left',
    fontFamily: 'Nunito Sans',
    fontWeight: 700,
    lineHeight: 1.167,
    letterSpacing: '0.03em',
    padding: '15px',
    background: '#F3F4FE',
    boxShadow: '0px 4px 20px rgba(170, 170, 170, 0.25)',
    borderRadius: '10px',
    marginBottom: '0px',
    marginTop: '20px',
    marginLeft: '27px',
    marginRight: '40px',
  },
});

export default withStyles(styles)(YtDetailedInsights);

// const useStyles = makeStyles(() => ({
//     a:{
//         fontSize:100
//     }
// }));
